module.exports = __webpack_public_path__ + "img/logo.e597fdd9.png";